//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAuthClient {
    login(command: LoginCommand): Observable<ApiResponseOfString>;
    resetPassword(command: ResetPasswordCommand): Observable<ApiResponseOfString>;
    resetPasswordByLink(command: ResetPasswordByLinkCommand): Observable<ApiResponseOfString>;
    sendPasswordLink(command: SendPasswordResetLinkCommand): Observable<ApiResponseOfString>;
    checkLinkStatus(command: CheckLinkStatusCommand): Observable<ApiResponseOfBoolean>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthClient implements IAuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    login(command: LoginCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(command: ResetPasswordCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordByLink(command: ResetPasswordByLinkCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Auth/reset-password-by-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordByLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordByLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processResetPasswordByLink(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendPasswordLink(command: SendPasswordResetLinkCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Auth/send-password-reset-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processSendPasswordLink(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkLinkStatus(command: CheckLinkStatusCommand): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/Auth/check-link-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLinkStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLinkStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processCheckLinkStatus(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IClientClient {
    getClients(): Observable<ApiResponseOfIListOfClientDto>;
    createClient(command: CreateClientCommand): Observable<ApiResponseOfClientDto>;
    updateClient(command: UpdateClientCommand): Observable<ApiResponseOfClientDto>;
    getClientById(id: number): Observable<ApiResponseOfClientDto>;
    deleteClient(id: number): Observable<ApiResponseOfInteger>;
}

@Injectable({
    providedIn: 'root'
})
export class ClientClient implements IClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getClients(): Observable<ApiResponseOfIListOfClientDto> {
        let url_ = this.baseUrl + "/api/Client";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfClientDto>;
        }));
    }

    protected processGetClients(response: HttpResponseBase): Observable<ApiResponseOfIListOfClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createClient(command: CreateClientCommand): Observable<ApiResponseOfClientDto> {
        let url_ = this.baseUrl + "/api/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfClientDto>;
        }));
    }

    protected processCreateClient(response: HttpResponseBase): Observable<ApiResponseOfClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateClient(command: UpdateClientCommand): Observable<ApiResponseOfClientDto> {
        let url_ = this.baseUrl + "/api/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfClientDto>;
        }));
    }

    protected processUpdateClient(response: HttpResponseBase): Observable<ApiResponseOfClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientById(id: number): Observable<ApiResponseOfClientDto> {
        let url_ = this.baseUrl + "/api/Client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfClientDto>;
        }));
    }

    protected processGetClientById(response: HttpResponseBase): Observable<ApiResponseOfClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteClient(id: number): Observable<ApiResponseOfInteger> {
        let url_ = this.baseUrl + "/api/Client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInteger>;
        }));
    }

    protected processDeleteClient(response: HttpResponseBase): Observable<ApiResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDashboardClient {
    getDashboard(): Observable<ApiResponseOfDashboardDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DashboardClient implements IDashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDashboard(): Observable<ApiResponseOfDashboardDto> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDashboardDto>;
        }));
    }

    protected processGetDashboard(response: HttpResponseBase): Observable<ApiResponseOfDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmailClient {
    sendTestEmail(command: SendTestEmailCommand): Observable<ApiResponseOfBoolean>;
    sendContactUsEmail(command: SendContactUsEmailCommand): Observable<ApiResponseOfBoolean>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailClient implements IEmailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    sendTestEmail(command: SendTestEmailCommand): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/Email/test-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendContactUsEmail(command: SendContactUsEmailCommand): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/Email/contact-us";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendContactUsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendContactUsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfBoolean>;
        }));
    }

    protected processSendContactUsEmail(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFileClient {
    getFile(filePath: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class FileClient implements IFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getFile(filePath: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/File?";
        if (filePath === null)
            throw new Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectClient {
    getProjects(): Observable<ApiResponseOfIListOfProjectDto>;
    createProject(clientId: number | undefined, serviceTypeId: number | undefined, clientTestimonial: string | null | undefined, projectSummary: string | null | undefined, projectDescription: string | null | undefined, solution: string | null | undefined, results: string | null | undefined, benefits: string | null | undefined, duration: string | null | undefined, projectTechnology: string | null | undefined, projectImage: FileParameter | null | undefined): Observable<ApiResponseOfProjectDto>;
    updateProject(projectId: number | undefined, clientId: number | undefined, serviceTypeId: number | undefined, clientTestimonial: string | null | undefined, projectSummary: string | null | undefined, projectDescription: string | null | undefined, solution: string | null | undefined, results: string | null | undefined, benefits: string | null | undefined, duration: string | null | undefined, projectTechnology: string | null | undefined, projectImage: FileParameter | null | undefined): Observable<ApiResponseOfProjectDto>;
    getProjectsForWebsite(): Observable<ApiResponseOfIListOfProjectDto>;
    getProjectById(id: number): Observable<ApiResponseOfProjectDto>;
    deleteProject(id: number): Observable<ApiResponseOfInteger>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectClient implements IProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getProjects(): Observable<ApiResponseOfIListOfProjectDto> {
        let url_ = this.baseUrl + "/api/Project";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfProjectDto>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<ApiResponseOfIListOfProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createProject(clientId: number | undefined, serviceTypeId: number | undefined, clientTestimonial: string | null | undefined, projectSummary: string | null | undefined, projectDescription: string | null | undefined, solution: string | null | undefined, results: string | null | undefined, benefits: string | null | undefined, duration: string | null | undefined, projectTechnology: string | null | undefined, projectImage: FileParameter | null | undefined): Observable<ApiResponseOfProjectDto> {
        let url_ = this.baseUrl + "/api/Project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (clientId === null || clientId === undefined)
            throw new Error("The parameter 'clientId' cannot be null.");
        else
            content_.append("ClientId", clientId.toString());
        if (serviceTypeId === null || serviceTypeId === undefined)
            throw new Error("The parameter 'serviceTypeId' cannot be null.");
        else
            content_.append("ServiceTypeId", serviceTypeId.toString());
        if (clientTestimonial !== null && clientTestimonial !== undefined)
            content_.append("ClientTestimonial", clientTestimonial.toString());
        if (projectSummary !== null && projectSummary !== undefined)
            content_.append("ProjectSummary", projectSummary.toString());
        if (projectDescription !== null && projectDescription !== undefined)
            content_.append("ProjectDescription", projectDescription.toString());
        if (solution !== null && solution !== undefined)
            content_.append("Solution", solution.toString());
        if (results !== null && results !== undefined)
            content_.append("Results", results.toString());
        if (benefits !== null && benefits !== undefined)
            content_.append("Benefits", benefits.toString());
        if (duration !== null && duration !== undefined)
            content_.append("Duration", duration.toString());
        if (projectTechnology !== null && projectTechnology !== undefined)
            content_.append("ProjectTechnology", projectTechnology.toString());
        if (projectImage !== null && projectImage !== undefined)
            content_.append("ProjectImage", projectImage.data, projectImage.fileName ? projectImage.fileName : "ProjectImage");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfProjectDto>;
        }));
    }

    protected processCreateProject(response: HttpResponseBase): Observable<ApiResponseOfProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProject(projectId: number | undefined, clientId: number | undefined, serviceTypeId: number | undefined, clientTestimonial: string | null | undefined, projectSummary: string | null | undefined, projectDescription: string | null | undefined, solution: string | null | undefined, results: string | null | undefined, benefits: string | null | undefined, duration: string | null | undefined, projectTechnology: string | null | undefined, projectImage: FileParameter | null | undefined): Observable<ApiResponseOfProjectDto> {
        let url_ = this.baseUrl + "/api/Project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId === null || projectId === undefined)
            throw new Error("The parameter 'projectId' cannot be null.");
        else
            content_.append("ProjectId", projectId.toString());
        if (clientId === null || clientId === undefined)
            throw new Error("The parameter 'clientId' cannot be null.");
        else
            content_.append("ClientId", clientId.toString());
        if (serviceTypeId === null || serviceTypeId === undefined)
            throw new Error("The parameter 'serviceTypeId' cannot be null.");
        else
            content_.append("ServiceTypeId", serviceTypeId.toString());
        if (clientTestimonial !== null && clientTestimonial !== undefined)
            content_.append("ClientTestimonial", clientTestimonial.toString());
        if (projectSummary !== null && projectSummary !== undefined)
            content_.append("ProjectSummary", projectSummary.toString());
        if (projectDescription !== null && projectDescription !== undefined)
            content_.append("ProjectDescription", projectDescription.toString());
        if (solution !== null && solution !== undefined)
            content_.append("Solution", solution.toString());
        if (results !== null && results !== undefined)
            content_.append("Results", results.toString());
        if (benefits !== null && benefits !== undefined)
            content_.append("Benefits", benefits.toString());
        if (duration !== null && duration !== undefined)
            content_.append("Duration", duration.toString());
        if (projectTechnology !== null && projectTechnology !== undefined)
            content_.append("ProjectTechnology", projectTechnology.toString());
        if (projectImage !== null && projectImage !== undefined)
            content_.append("ProjectImage", projectImage.data, projectImage.fileName ? projectImage.fileName : "ProjectImage");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfProjectDto>;
        }));
    }

    protected processUpdateProject(response: HttpResponseBase): Observable<ApiResponseOfProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectsForWebsite(): Observable<ApiResponseOfIListOfProjectDto> {
        let url_ = this.baseUrl + "/api/Project/get-projects-website";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsForWebsite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsForWebsite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfProjectDto>;
        }));
    }

    protected processGetProjectsForWebsite(response: HttpResponseBase): Observable<ApiResponseOfIListOfProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectById(id: number): Observable<ApiResponseOfProjectDto> {
        let url_ = this.baseUrl + "/api/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfProjectDto>;
        }));
    }

    protected processGetProjectById(response: HttpResponseBase): Observable<ApiResponseOfProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProject(id: number): Observable<ApiResponseOfInteger> {
        let url_ = this.baseUrl + "/api/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInteger>;
        }));
    }

    protected processDeleteProject(response: HttpResponseBase): Observable<ApiResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPromotionApplicationClient {
    getPromotionApplicationCount(id: number): Observable<ApiResponseOfInteger>;
    downloadPromotionApplicationAsCsv(id: number): Observable<FileResponse>;
    createPromotionApplication(command: CreatePromotionApplicationCommand): Observable<ApiResponseOfPromotionApplicationDto>;
}

@Injectable({
    providedIn: 'root'
})
export class PromotionApplicationClient implements IPromotionApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPromotionApplicationCount(id: number): Observable<ApiResponseOfInteger> {
        let url_ = this.baseUrl + "/api/PromotionApplication/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotionApplicationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotionApplicationCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInteger>;
        }));
    }

    protected processGetPromotionApplicationCount(response: HttpResponseBase): Observable<ApiResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadPromotionApplicationAsCsv(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PromotionApplication/get-promotions-application/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPromotionApplicationAsCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPromotionApplicationAsCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPromotionApplicationAsCsv(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPromotionApplication(command: CreatePromotionApplicationCommand): Observable<ApiResponseOfPromotionApplicationDto> {
        let url_ = this.baseUrl + "/api/PromotionApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePromotionApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePromotionApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPromotionApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPromotionApplicationDto>;
        }));
    }

    protected processCreatePromotionApplication(response: HttpResponseBase): Observable<ApiResponseOfPromotionApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfPromotionApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPromotionClient {
    getPromotions(): Observable<ApiResponseOfIListOfPromotionDto>;
    createPromotion(promotionName: string | null | undefined, promotionSummary: string | null | undefined, promotionDescription: string | null | undefined, promotionImage: FileParameter | null | undefined, promotionQuestion: string | null | undefined, promotionEndDate: Date | undefined): Observable<ApiResponseOfPromotionDto>;
    updatePromotion(promotionId: number | undefined, promotionName: string | null | undefined, promotionSummary: string | null | undefined, promotionDescription: string | null | undefined, promotionImage: FileParameter | null | undefined, promotionQuestion: string | null | undefined, promotionEndDate: Date | undefined): Observable<ApiResponseOfPromotionDto>;
    getPromotionsForWebsite(): Observable<ApiResponseOfIListOfPromotionDto>;
    getPromotionsCountForWebsite(): Observable<ApiResponseOfInteger>;
    getPromotionById(id: number): Observable<ApiResponseOfPromotionDto>;
    deletePromotion(id: number): Observable<ApiResponseOfInteger>;
}

@Injectable({
    providedIn: 'root'
})
export class PromotionClient implements IPromotionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPromotions(): Observable<ApiResponseOfIListOfPromotionDto> {
        let url_ = this.baseUrl + "/api/Promotion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfPromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfPromotionDto>;
        }));
    }

    protected processGetPromotions(response: HttpResponseBase): Observable<ApiResponseOfIListOfPromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfPromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPromotion(promotionName: string | null | undefined, promotionSummary: string | null | undefined, promotionDescription: string | null | undefined, promotionImage: FileParameter | null | undefined, promotionQuestion: string | null | undefined, promotionEndDate: Date | undefined): Observable<ApiResponseOfPromotionDto> {
        let url_ = this.baseUrl + "/api/Promotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (promotionName !== null && promotionName !== undefined)
            content_.append("PromotionName", promotionName.toString());
        if (promotionSummary !== null && promotionSummary !== undefined)
            content_.append("PromotionSummary", promotionSummary.toString());
        if (promotionDescription !== null && promotionDescription !== undefined)
            content_.append("PromotionDescription", promotionDescription.toString());
        if (promotionImage !== null && promotionImage !== undefined)
            content_.append("PromotionImage", promotionImage.data, promotionImage.fileName ? promotionImage.fileName : "PromotionImage");
        if (promotionQuestion !== null && promotionQuestion !== undefined)
            content_.append("PromotionQuestion", promotionQuestion.toString());
        if (promotionEndDate === null || promotionEndDate === undefined)
            throw new Error("The parameter 'promotionEndDate' cannot be null.");
        else
            content_.append("PromotionEndDate", promotionEndDate.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPromotionDto>;
        }));
    }

    protected processCreatePromotion(response: HttpResponseBase): Observable<ApiResponseOfPromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfPromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePromotion(promotionId: number | undefined, promotionName: string | null | undefined, promotionSummary: string | null | undefined, promotionDescription: string | null | undefined, promotionImage: FileParameter | null | undefined, promotionQuestion: string | null | undefined, promotionEndDate: Date | undefined): Observable<ApiResponseOfPromotionDto> {
        let url_ = this.baseUrl + "/api/Promotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (promotionId === null || promotionId === undefined)
            throw new Error("The parameter 'promotionId' cannot be null.");
        else
            content_.append("PromotionId", promotionId.toString());
        if (promotionName !== null && promotionName !== undefined)
            content_.append("PromotionName", promotionName.toString());
        if (promotionSummary !== null && promotionSummary !== undefined)
            content_.append("PromotionSummary", promotionSummary.toString());
        if (promotionDescription !== null && promotionDescription !== undefined)
            content_.append("PromotionDescription", promotionDescription.toString());
        if (promotionImage !== null && promotionImage !== undefined)
            content_.append("PromotionImage", promotionImage.data, promotionImage.fileName ? promotionImage.fileName : "PromotionImage");
        if (promotionQuestion !== null && promotionQuestion !== undefined)
            content_.append("PromotionQuestion", promotionQuestion.toString());
        if (promotionEndDate === null || promotionEndDate === undefined)
            throw new Error("The parameter 'promotionEndDate' cannot be null.");
        else
            content_.append("PromotionEndDate", promotionEndDate.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPromotionDto>;
        }));
    }

    protected processUpdatePromotion(response: HttpResponseBase): Observable<ApiResponseOfPromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfPromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPromotionsForWebsite(): Observable<ApiResponseOfIListOfPromotionDto> {
        let url_ = this.baseUrl + "/api/Promotion/get-promotions-website";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotionsForWebsite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotionsForWebsite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfPromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfPromotionDto>;
        }));
    }

    protected processGetPromotionsForWebsite(response: HttpResponseBase): Observable<ApiResponseOfIListOfPromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfPromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPromotionsCountForWebsite(): Observable<ApiResponseOfInteger> {
        let url_ = this.baseUrl + "/api/Promotion/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotionsCountForWebsite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotionsCountForWebsite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInteger>;
        }));
    }

    protected processGetPromotionsCountForWebsite(response: HttpResponseBase): Observable<ApiResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPromotionById(id: number): Observable<ApiResponseOfPromotionDto> {
        let url_ = this.baseUrl + "/api/Promotion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPromotionDto>;
        }));
    }

    protected processGetPromotionById(response: HttpResponseBase): Observable<ApiResponseOfPromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfPromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePromotion(id: number): Observable<ApiResponseOfInteger> {
        let url_ = this.baseUrl + "/api/Promotion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInteger>;
        }));
    }

    protected processDeletePromotion(response: HttpResponseBase): Observable<ApiResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRoleClient {
    getRoles(): Observable<ApiResponseOfIListOfRoleDto>;
}

@Injectable({
    providedIn: 'root'
})
export class RoleClient implements IRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getRoles(): Observable<ApiResponseOfIListOfRoleDto> {
        let url_ = this.baseUrl + "/api/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfRoleDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ApiResponseOfIListOfRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceTypeClient {
    getServiceTypes(): Observable<ApiResponseOfIListOfServiceTypeDto>;
    createServiceType(command: CreateServiceTypeCommand): Observable<ApiResponseOfServiceTypeDto>;
    updateServiceType(command: UpdateServiceTypeCommand): Observable<ApiResponseOfServiceTypeDto>;
    getServiceTypesForWebsite(): Observable<ApiResponseOfIListOfServiceTypeDto>;
    getServiceTypeById(id: number): Observable<ApiResponseOfServiceTypeDto>;
    deleteServiceType(id: number): Observable<ApiResponseOfInteger>;
}

@Injectable({
    providedIn: 'root'
})
export class ServiceTypeClient implements IServiceTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getServiceTypes(): Observable<ApiResponseOfIListOfServiceTypeDto> {
        let url_ = this.baseUrl + "/api/ServiceType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfServiceTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfServiceTypeDto>;
        }));
    }

    protected processGetServiceTypes(response: HttpResponseBase): Observable<ApiResponseOfIListOfServiceTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfServiceTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createServiceType(command: CreateServiceTypeCommand): Observable<ApiResponseOfServiceTypeDto> {
        let url_ = this.baseUrl + "/api/ServiceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfServiceTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfServiceTypeDto>;
        }));
    }

    protected processCreateServiceType(response: HttpResponseBase): Observable<ApiResponseOfServiceTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfServiceTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateServiceType(command: UpdateServiceTypeCommand): Observable<ApiResponseOfServiceTypeDto> {
        let url_ = this.baseUrl + "/api/ServiceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfServiceTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfServiceTypeDto>;
        }));
    }

    protected processUpdateServiceType(response: HttpResponseBase): Observable<ApiResponseOfServiceTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfServiceTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceTypesForWebsite(): Observable<ApiResponseOfIListOfServiceTypeDto> {
        let url_ = this.baseUrl + "/api/ServiceType/get-services-website";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTypesForWebsite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTypesForWebsite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfServiceTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfServiceTypeDto>;
        }));
    }

    protected processGetServiceTypesForWebsite(response: HttpResponseBase): Observable<ApiResponseOfIListOfServiceTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfServiceTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceTypeById(id: number): Observable<ApiResponseOfServiceTypeDto> {
        let url_ = this.baseUrl + "/api/ServiceType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfServiceTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfServiceTypeDto>;
        }));
    }

    protected processGetServiceTypeById(response: HttpResponseBase): Observable<ApiResponseOfServiceTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfServiceTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteServiceType(id: number): Observable<ApiResponseOfInteger> {
        let url_ = this.baseUrl + "/api/ServiceType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInteger>;
        }));
    }

    protected processDeleteServiceType(response: HttpResponseBase): Observable<ApiResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    getUsers(): Observable<ApiResponseOfIListOfUserDto>;
    createUser(command: CreateUserCommand): Observable<ApiResponseOfString>;
    updateUser(command: UpdateUserCommand): Observable<ApiResponseOfUserDto>;
    getUserById(id: string): Observable<ApiResponseOfUserDto>;
    deleteUser(id: string): Observable<ApiResponseOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUsers(): Observable<ApiResponseOfIListOfUserDto> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfUserDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<ApiResponseOfIListOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createUser(command: CreateUserCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(command: UpdateUserCommand): Observable<ApiResponseOfUserDto> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfUserDto>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<ApiResponseOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserById(id: string): Observable<ApiResponseOfUserDto> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfUserDto>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<ApiResponseOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUser(id: string): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVacancyApplicationClient {
    getVacancyApplications(id: number | undefined): Observable<ApiResponseOfVacancyDto>;
    updateVacancyApplication(command: UpdateVacancyApplicationCommand): Observable<ApiResponseOfVacancyApplicationDto>;
    getVacancyApplicationById(id: number): Observable<ApiResponseOfVacancyApplicationDto>;
    deleteVacancyApplication(id: number): Observable<ApiResponseOfInteger>;
}

@Injectable({
    providedIn: 'root'
})
export class VacancyApplicationClient implements IVacancyApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getVacancyApplications(id: number | undefined): Observable<ApiResponseOfVacancyDto> {
        let url_ = this.baseUrl + "/api/VacancyApplication?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacancyApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacancyApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVacancyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVacancyDto>;
        }));
    }

    protected processGetVacancyApplications(response: HttpResponseBase): Observable<ApiResponseOfVacancyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfVacancyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVacancyApplication(command: UpdateVacancyApplicationCommand): Observable<ApiResponseOfVacancyApplicationDto> {
        let url_ = this.baseUrl + "/api/VacancyApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVacancyApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVacancyApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVacancyApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVacancyApplicationDto>;
        }));
    }

    protected processUpdateVacancyApplication(response: HttpResponseBase): Observable<ApiResponseOfVacancyApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfVacancyApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacancyApplicationById(id: number): Observable<ApiResponseOfVacancyApplicationDto> {
        let url_ = this.baseUrl + "/api/VacancyApplication/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacancyApplicationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacancyApplicationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVacancyApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVacancyApplicationDto>;
        }));
    }

    protected processGetVacancyApplicationById(response: HttpResponseBase): Observable<ApiResponseOfVacancyApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfVacancyApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVacancyApplication(id: number): Observable<ApiResponseOfInteger> {
        let url_ = this.baseUrl + "/api/VacancyApplication/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVacancyApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVacancyApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInteger>;
        }));
    }

    protected processDeleteVacancyApplication(response: HttpResponseBase): Observable<ApiResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVacancyClient {
    getVacancies(): Observable<ApiResponseOfIListOfVacancyWithApplicationCount>;
    createVacancy(command: CreateVacancyCommand): Observable<ApiResponseOfVacancyDto>;
    updateVacancy(command: UpdateVacancyCommand): Observable<ApiResponseOfVacancyDto>;
    getVacanciesForWebsite(): Observable<ApiResponseOfIListOfVacancyDto>;
    getVacancyById(id: number): Observable<ApiResponseOfVacancyDto>;
    deleteVacancy(id: number): Observable<ApiResponseOfInteger>;
    applyVacancy(vacancyId: number | undefined, position: string | null | undefined, name: string | null | undefined, email: string | null | undefined, phone: string | null | undefined, attachments: FileParameter[] | null | undefined): Observable<ApiResponseOfInteger>;
}

@Injectable({
    providedIn: 'root'
})
export class VacancyClient implements IVacancyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getVacancies(): Observable<ApiResponseOfIListOfVacancyWithApplicationCount> {
        let url_ = this.baseUrl + "/api/Vacancy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacancies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacancies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfVacancyWithApplicationCount>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfVacancyWithApplicationCount>;
        }));
    }

    protected processGetVacancies(response: HttpResponseBase): Observable<ApiResponseOfIListOfVacancyWithApplicationCount> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfVacancyWithApplicationCount.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createVacancy(command: CreateVacancyCommand): Observable<ApiResponseOfVacancyDto> {
        let url_ = this.baseUrl + "/api/Vacancy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVacancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVacancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVacancyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVacancyDto>;
        }));
    }

    protected processCreateVacancy(response: HttpResponseBase): Observable<ApiResponseOfVacancyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfVacancyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVacancy(command: UpdateVacancyCommand): Observable<ApiResponseOfVacancyDto> {
        let url_ = this.baseUrl + "/api/Vacancy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVacancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVacancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVacancyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVacancyDto>;
        }));
    }

    protected processUpdateVacancy(response: HttpResponseBase): Observable<ApiResponseOfVacancyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfVacancyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacanciesForWebsite(): Observable<ApiResponseOfIListOfVacancyDto> {
        let url_ = this.baseUrl + "/api/Vacancy/get-vacancies-website";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacanciesForWebsite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacanciesForWebsite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfVacancyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfVacancyDto>;
        }));
    }

    protected processGetVacanciesForWebsite(response: HttpResponseBase): Observable<ApiResponseOfIListOfVacancyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfIListOfVacancyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacancyById(id: number): Observable<ApiResponseOfVacancyDto> {
        let url_ = this.baseUrl + "/api/Vacancy/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacancyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacancyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVacancyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVacancyDto>;
        }));
    }

    protected processGetVacancyById(response: HttpResponseBase): Observable<ApiResponseOfVacancyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfVacancyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVacancy(id: number): Observable<ApiResponseOfInteger> {
        let url_ = this.baseUrl + "/api/Vacancy/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVacancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVacancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInteger>;
        }));
    }

    protected processDeleteVacancy(response: HttpResponseBase): Observable<ApiResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applyVacancy(vacancyId: number | undefined, position: string | null | undefined, name: string | null | undefined, email: string | null | undefined, phone: string | null | undefined, attachments: FileParameter[] | null | undefined): Observable<ApiResponseOfInteger> {
        let url_ = this.baseUrl + "/api/Vacancy/apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (vacancyId === null || vacancyId === undefined)
            throw new Error("The parameter 'vacancyId' cannot be null.");
        else
            content_.append("VacancyId", vacancyId.toString());
        if (position !== null && position !== undefined)
            content_.append("Position", position.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (phone !== null && phone !== undefined)
            content_.append("Phone", phone.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyVacancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyVacancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInteger>;
        }));
    }

    protected processApplyVacancy(response: HttpResponseBase): Observable<ApiResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ApiResponseOfString implements IApiResponseOfString {
    status?: string;
    data?: string | undefined;
    message?: string;

    constructor(data?: IApiResponseOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfString {
    status?: string;
    data?: string | undefined;
    message?: string;
}

export class LoginCommand implements ILoginCommand {
    email?: string;
    password?: string;

    constructor(data?: ILoginCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginCommand {
    email?: string;
    password?: string;
}

export class ResetPasswordCommand implements IResetPasswordCommand {
    password?: string;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        return data;
    }
}

export interface IResetPasswordCommand {
    password?: string;
}

export class ResetPasswordByLinkCommand implements IResetPasswordByLinkCommand {
    token?: string;
    password?: string;

    constructor(data?: IResetPasswordByLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordByLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordByLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["password"] = this.password;
        return data;
    }
}

export interface IResetPasswordByLinkCommand {
    token?: string;
    password?: string;
}

export class SendPasswordResetLinkCommand implements ISendPasswordResetLinkCommand {
    email?: string;

    constructor(data?: ISendPasswordResetLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SendPasswordResetLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ISendPasswordResetLinkCommand {
    email?: string;
}

export class ApiResponseOfBoolean implements IApiResponseOfBoolean {
    status?: string;
    data?: boolean;
    message?: string;

    constructor(data?: IApiResponseOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfBoolean {
    status?: string;
    data?: boolean;
    message?: string;
}

export class CheckLinkStatusCommand implements ICheckLinkStatusCommand {
    link?: string;

    constructor(data?: ICheckLinkStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): CheckLinkStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckLinkStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        return data;
    }
}

export interface ICheckLinkStatusCommand {
    link?: string;
}

export class ApiResponseOfIListOfClientDto implements IApiResponseOfIListOfClientDto {
    status?: string;
    data?: ClientDto[] | undefined;
    message?: string;

    constructor(data?: IApiResponseOfIListOfClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClientDto.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfIListOfClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfIListOfClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfIListOfClientDto {
    status?: string;
    data?: ClientDto[] | undefined;
    message?: string;
}

export class BaseDto implements IBaseDto {
    createdAt?: Date;
    createdBy?: string | undefined;
    lastModifiedAt?: Date | undefined;
    lastModifiedBy?: string | undefined;
    isDeleted?: boolean;
    createdByUser?: UserDto;
    lastModifiedByUser?: UserDto;

    constructor(data?: IBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.isDeleted = _data["isDeleted"];
            this.createdByUser = _data["createdByUser"] ? UserDto.fromJS(_data["createdByUser"]) : <any>undefined;
            this.lastModifiedByUser = _data["lastModifiedByUser"] ? UserDto.fromJS(_data["lastModifiedByUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["isDeleted"] = this.isDeleted;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["lastModifiedByUser"] = this.lastModifiedByUser ? this.lastModifiedByUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseDto {
    createdAt?: Date;
    createdBy?: string | undefined;
    lastModifiedAt?: Date | undefined;
    lastModifiedBy?: string | undefined;
    isDeleted?: boolean;
    createdByUser?: UserDto;
    lastModifiedByUser?: UserDto;
}

export class ClientDto extends BaseDto implements IClientDto {
    clientId?: number;
    clientName?: string;
    description?: string;

    constructor(data?: IClientDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.description = _data["description"];
        }
    }

    static override fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IClientDto extends IBaseDto {
    clientId?: number;
    clientName?: string;
    description?: string;
}

export class UserDto implements IUserDto {
    userId?: string;
    email?: string;
    passwordHash?: string;
    passwordSalt?: string;
    roles?: Role[];

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.passwordHash = _data["passwordHash"];
            this.passwordSalt = _data["passwordSalt"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["passwordHash"] = this.passwordHash;
        data["passwordSalt"] = this.passwordSalt;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDto {
    userId?: string;
    email?: string;
    passwordHash?: string;
    passwordSalt?: string;
    roles?: Role[];
}

export class Role implements IRole {
    roleId?: number;
    roleName?: string;
    users?: User[];

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRole {
    roleId?: number;
    roleName?: string;
    users?: User[];
}

export class User implements IUser {
    userId?: string;
    email?: string;
    passwordHash?: string;
    passwordSalt?: string;
    roles?: Role[];

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.passwordHash = _data["passwordHash"];
            this.passwordSalt = _data["passwordSalt"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["passwordHash"] = this.passwordHash;
        data["passwordSalt"] = this.passwordSalt;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUser {
    userId?: string;
    email?: string;
    passwordHash?: string;
    passwordSalt?: string;
    roles?: Role[];
}

export class ApiResponseOfClientDto implements IApiResponseOfClientDto {
    status?: string;
    data?: ClientDto | undefined;
    message?: string;

    constructor(data?: IApiResponseOfClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? ClientDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfClientDto {
    status?: string;
    data?: ClientDto | undefined;
    message?: string;
}

export class CreateClientCommand implements ICreateClientCommand {
    clientName?: string;
    description?: string;

    constructor(data?: ICreateClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateClientCommand {
    clientName?: string;
    description?: string;
}

export class UpdateClientCommand implements IUpdateClientCommand {
    clientId?: number;
    clientName?: string;
    description?: string;

    constructor(data?: IUpdateClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateClientCommand {
    clientId?: number;
    clientName?: string;
    description?: string;
}

export class ApiResponseOfInteger implements IApiResponseOfInteger {
    status?: string;
    data?: number;
    message?: string;

    constructor(data?: IApiResponseOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfInteger {
    status?: string;
    data?: number;
    message?: string;
}

export class ApiResponseOfDashboardDto implements IApiResponseOfDashboardDto {
    status?: string;
    data?: DashboardDto | undefined;
    message?: string;

    constructor(data?: IApiResponseOfDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? DashboardDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfDashboardDto {
    status?: string;
    data?: DashboardDto | undefined;
    message?: string;
}

export class DashboardDto implements IDashboardDto {
    clientsCount?: number;
    projectsCount?: number;
    vacanciesCount?: number;
    usersCount?: number;

    constructor(data?: IDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientsCount = _data["clientsCount"];
            this.projectsCount = _data["projectsCount"];
            this.vacanciesCount = _data["vacanciesCount"];
            this.usersCount = _data["usersCount"];
        }
    }

    static fromJS(data: any): DashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientsCount"] = this.clientsCount;
        data["projectsCount"] = this.projectsCount;
        data["vacanciesCount"] = this.vacanciesCount;
        data["usersCount"] = this.usersCount;
        return data;
    }
}

export interface IDashboardDto {
    clientsCount?: number;
    projectsCount?: number;
    vacanciesCount?: number;
    usersCount?: number;
}

export class SendTestEmailCommand implements ISendTestEmailCommand {
    email?: string;

    constructor(data?: ISendTestEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SendTestEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ISendTestEmailCommand {
    email?: string;
}

export class SendContactUsEmailCommand implements ISendContactUsEmailCommand {
    name?: string;
    email?: string;
    phone?: string;
    company?: string;
    country?: string;
    message?: string;

    constructor(data?: ISendContactUsEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.company = _data["company"];
            this.country = _data["country"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendContactUsEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendContactUsEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["company"] = this.company;
        data["country"] = this.country;
        data["message"] = this.message;
        return data;
    }
}

export interface ISendContactUsEmailCommand {
    name?: string;
    email?: string;
    phone?: string;
    company?: string;
    country?: string;
    message?: string;
}

export class ApiResponseOfIListOfProjectDto implements IApiResponseOfIListOfProjectDto {
    status?: string;
    data?: ProjectDto[] | undefined;
    message?: string;

    constructor(data?: IApiResponseOfIListOfProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProjectDto.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfIListOfProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfIListOfProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfIListOfProjectDto {
    status?: string;
    data?: ProjectDto[] | undefined;
    message?: string;
}

export class ProjectDto extends BaseDto implements IProjectDto {
    projectId?: number;
    clientId?: number;
    serviceTypeId?: number;
    clientTestimonial?: string | undefined;
    projectSummary?: string;
    projectDescription?: string;
    solution?: string;
    results?: string;
    benefits?: string;
    duration?: string;
    projectTechnology?: string;
    projectImageUrl?: string;
    client?: Client;
    serviceType?: ServiceType;

    constructor(data?: IProjectDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"];
            this.clientId = _data["clientId"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.clientTestimonial = _data["clientTestimonial"];
            this.projectSummary = _data["projectSummary"];
            this.projectDescription = _data["projectDescription"];
            this.solution = _data["solution"];
            this.results = _data["results"];
            this.benefits = _data["benefits"];
            this.duration = _data["duration"];
            this.projectTechnology = _data["projectTechnology"];
            this.projectImageUrl = _data["projectImageUrl"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.serviceType = _data["serviceType"] ? ServiceType.fromJS(_data["serviceType"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["clientId"] = this.clientId;
        data["serviceTypeId"] = this.serviceTypeId;
        data["clientTestimonial"] = this.clientTestimonial;
        data["projectSummary"] = this.projectSummary;
        data["projectDescription"] = this.projectDescription;
        data["solution"] = this.solution;
        data["results"] = this.results;
        data["benefits"] = this.benefits;
        data["duration"] = this.duration;
        data["projectTechnology"] = this.projectTechnology;
        data["projectImageUrl"] = this.projectImageUrl;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["serviceType"] = this.serviceType ? this.serviceType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectDto extends IBaseDto {
    projectId?: number;
    clientId?: number;
    serviceTypeId?: number;
    clientTestimonial?: string | undefined;
    projectSummary?: string;
    projectDescription?: string;
    solution?: string;
    results?: string;
    benefits?: string;
    duration?: string;
    projectTechnology?: string;
    projectImageUrl?: string;
    client?: Client;
    serviceType?: ServiceType;
}

export abstract class BaseEntity implements IBaseEntity {
    domainEvents?: BaseEvent[];

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["domainEvents"])) {
                this.domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    this.domainEvents!.push(BaseEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBaseEntity {
    domainEvents?: BaseEvent[];
}

export abstract class BaseAuditableEntity extends BaseEntity implements IBaseAuditableEntity {
    createdAt?: Date;
    createdBy?: string | undefined;
    lastModifiedAt?: Date | undefined;
    lastModifiedBy?: string | undefined;
    isDeleted?: boolean;
    createdByUser?: User;
    lastModifiedByUser?: User;

    constructor(data?: IBaseAuditableEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.isDeleted = _data["isDeleted"];
            this.createdByUser = _data["createdByUser"] ? User.fromJS(_data["createdByUser"]) : <any>undefined;
            this.lastModifiedByUser = _data["lastModifiedByUser"] ? User.fromJS(_data["lastModifiedByUser"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BaseAuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseAuditableEntity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["isDeleted"] = this.isDeleted;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["lastModifiedByUser"] = this.lastModifiedByUser ? this.lastModifiedByUser.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseAuditableEntity extends IBaseEntity {
    createdAt?: Date;
    createdBy?: string | undefined;
    lastModifiedAt?: Date | undefined;
    lastModifiedBy?: string | undefined;
    isDeleted?: boolean;
    createdByUser?: User;
    lastModifiedByUser?: User;
}

export class Client extends BaseAuditableEntity implements IClient {
    clientId?: number;
    clientName?: string;
    description?: string;

    constructor(data?: IClient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.description = _data["description"];
        }
    }

    static override fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IClient extends IBaseAuditableEntity {
    clientId?: number;
    clientName?: string;
    description?: string;
}

export abstract class BaseEvent implements IBaseEvent {

    constructor(data?: IBaseEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseEvent {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseEvent {
}

export class ServiceType extends BaseAuditableEntity implements IServiceType {
    serviceTypeId?: number;
    serviceTypeName?: string;
    serviceTypeDescription?: string;

    constructor(data?: IServiceType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serviceTypeId = _data["serviceTypeId"];
            this.serviceTypeName = _data["serviceTypeName"];
            this.serviceTypeDescription = _data["serviceTypeDescription"];
        }
    }

    static override fromJS(data: any): ServiceType {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTypeId"] = this.serviceTypeId;
        data["serviceTypeName"] = this.serviceTypeName;
        data["serviceTypeDescription"] = this.serviceTypeDescription;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceType extends IBaseAuditableEntity {
    serviceTypeId?: number;
    serviceTypeName?: string;
    serviceTypeDescription?: string;
}

export class ApiResponseOfProjectDto implements IApiResponseOfProjectDto {
    status?: string;
    data?: ProjectDto | undefined;
    message?: string;

    constructor(data?: IApiResponseOfProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? ProjectDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfProjectDto {
    status?: string;
    data?: ProjectDto | undefined;
    message?: string;
}

export class ApiResponseOfPromotionApplicationDto implements IApiResponseOfPromotionApplicationDto {
    status?: string;
    data?: PromotionApplicationDto | undefined;
    message?: string;

    constructor(data?: IApiResponseOfPromotionApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? PromotionApplicationDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfPromotionApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfPromotionApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfPromotionApplicationDto {
    status?: string;
    data?: PromotionApplicationDto | undefined;
    message?: string;
}

export class PromotionApplicationDto implements IPromotionApplicationDto {
    promotionApplicationId?: number;
    promotionId?: number;
    fullName?: string;
    email?: string;
    phone?: string;
    questionAnswer?: string | undefined;
    entryDate?: Date;
    ipAddress?: string;

    constructor(data?: IPromotionApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promotionApplicationId = _data["promotionApplicationId"];
            this.promotionId = _data["promotionId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.questionAnswer = _data["questionAnswer"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): PromotionApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionApplicationId"] = this.promotionApplicationId;
        data["promotionId"] = this.promotionId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["questionAnswer"] = this.questionAnswer;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface IPromotionApplicationDto {
    promotionApplicationId?: number;
    promotionId?: number;
    fullName?: string;
    email?: string;
    phone?: string;
    questionAnswer?: string | undefined;
    entryDate?: Date;
    ipAddress?: string;
}

export class CreatePromotionApplicationCommand implements ICreatePromotionApplicationCommand {
    promotionId?: number;
    fullName?: string;
    email?: string;
    phone?: string;
    questionAnswer?: string | undefined;
    ipAddress?: string;

    constructor(data?: ICreatePromotionApplicationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promotionId = _data["promotionId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.questionAnswer = _data["questionAnswer"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): CreatePromotionApplicationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePromotionApplicationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionId"] = this.promotionId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["questionAnswer"] = this.questionAnswer;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface ICreatePromotionApplicationCommand {
    promotionId?: number;
    fullName?: string;
    email?: string;
    phone?: string;
    questionAnswer?: string | undefined;
    ipAddress?: string;
}

export class ApiResponseOfIListOfPromotionDto implements IApiResponseOfIListOfPromotionDto {
    status?: string;
    data?: PromotionDto[] | undefined;
    message?: string;

    constructor(data?: IApiResponseOfIListOfPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PromotionDto.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfIListOfPromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfIListOfPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfIListOfPromotionDto {
    status?: string;
    data?: PromotionDto[] | undefined;
    message?: string;
}

export class PromotionDto extends BaseDto implements IPromotionDto {
    promotionId?: number;
    promotionName?: string;
    promotionSummary?: string;
    promotionDescription?: string;
    promotionImageUrl?: string;
    promotionQuestion?: string | undefined;
    promotionEndDate?: Date;
    promotionApplications?: PromotionApplicationDto[];

    constructor(data?: IPromotionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.promotionId = _data["promotionId"];
            this.promotionName = _data["promotionName"];
            this.promotionSummary = _data["promotionSummary"];
            this.promotionDescription = _data["promotionDescription"];
            this.promotionImageUrl = _data["promotionImageUrl"];
            this.promotionQuestion = _data["promotionQuestion"];
            this.promotionEndDate = _data["promotionEndDate"] ? new Date(_data["promotionEndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["promotionApplications"])) {
                this.promotionApplications = [] as any;
                for (let item of _data["promotionApplications"])
                    this.promotionApplications!.push(PromotionApplicationDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionId"] = this.promotionId;
        data["promotionName"] = this.promotionName;
        data["promotionSummary"] = this.promotionSummary;
        data["promotionDescription"] = this.promotionDescription;
        data["promotionImageUrl"] = this.promotionImageUrl;
        data["promotionQuestion"] = this.promotionQuestion;
        data["promotionEndDate"] = this.promotionEndDate ? this.promotionEndDate.toISOString() : <any>undefined;
        if (Array.isArray(this.promotionApplications)) {
            data["promotionApplications"] = [];
            for (let item of this.promotionApplications)
                data["promotionApplications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPromotionDto extends IBaseDto {
    promotionId?: number;
    promotionName?: string;
    promotionSummary?: string;
    promotionDescription?: string;
    promotionImageUrl?: string;
    promotionQuestion?: string | undefined;
    promotionEndDate?: Date;
    promotionApplications?: PromotionApplicationDto[];
}

export class ApiResponseOfPromotionDto implements IApiResponseOfPromotionDto {
    status?: string;
    data?: PromotionDto | undefined;
    message?: string;

    constructor(data?: IApiResponseOfPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? PromotionDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfPromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfPromotionDto {
    status?: string;
    data?: PromotionDto | undefined;
    message?: string;
}

export class ApiResponseOfIListOfRoleDto implements IApiResponseOfIListOfRoleDto {
    status?: string;
    data?: RoleDto[] | undefined;
    message?: string;

    constructor(data?: IApiResponseOfIListOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RoleDto.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfIListOfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfIListOfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfIListOfRoleDto {
    status?: string;
    data?: RoleDto[] | undefined;
    message?: string;
}

export class RoleDto implements IRoleDto {
    roleId?: number;
    roleName?: string;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IRoleDto {
    roleId?: number;
    roleName?: string;
}

export class ApiResponseOfIListOfServiceTypeDto implements IApiResponseOfIListOfServiceTypeDto {
    status?: string;
    data?: ServiceTypeDto[] | undefined;
    message?: string;

    constructor(data?: IApiResponseOfIListOfServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ServiceTypeDto.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfIListOfServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfIListOfServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfIListOfServiceTypeDto {
    status?: string;
    data?: ServiceTypeDto[] | undefined;
    message?: string;
}

export class ServiceTypeDto extends BaseDto implements IServiceTypeDto {
    serviceTypeId?: number;
    serviceTypeName?: string;
    serviceTypeDescription?: string;

    constructor(data?: IServiceTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serviceTypeId = _data["serviceTypeId"];
            this.serviceTypeName = _data["serviceTypeName"];
            this.serviceTypeDescription = _data["serviceTypeDescription"];
        }
    }

    static override fromJS(data: any): ServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTypeId"] = this.serviceTypeId;
        data["serviceTypeName"] = this.serviceTypeName;
        data["serviceTypeDescription"] = this.serviceTypeDescription;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceTypeDto extends IBaseDto {
    serviceTypeId?: number;
    serviceTypeName?: string;
    serviceTypeDescription?: string;
}

export class ApiResponseOfServiceTypeDto implements IApiResponseOfServiceTypeDto {
    status?: string;
    data?: ServiceTypeDto | undefined;
    message?: string;

    constructor(data?: IApiResponseOfServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? ServiceTypeDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfServiceTypeDto {
    status?: string;
    data?: ServiceTypeDto | undefined;
    message?: string;
}

export class CreateServiceTypeCommand implements ICreateServiceTypeCommand {
    serviceTypeName?: string;
    serviceTypeDescription?: string;

    constructor(data?: ICreateServiceTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceTypeName = _data["serviceTypeName"];
            this.serviceTypeDescription = _data["serviceTypeDescription"];
        }
    }

    static fromJS(data: any): CreateServiceTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTypeName"] = this.serviceTypeName;
        data["serviceTypeDescription"] = this.serviceTypeDescription;
        return data;
    }
}

export interface ICreateServiceTypeCommand {
    serviceTypeName?: string;
    serviceTypeDescription?: string;
}

export class UpdateServiceTypeCommand implements IUpdateServiceTypeCommand {
    serviceTypeId?: number;
    serviceTypeName?: string;
    serviceTypeDescription?: string;

    constructor(data?: IUpdateServiceTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceTypeId = _data["serviceTypeId"];
            this.serviceTypeName = _data["serviceTypeName"];
            this.serviceTypeDescription = _data["serviceTypeDescription"];
        }
    }

    static fromJS(data: any): UpdateServiceTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTypeId"] = this.serviceTypeId;
        data["serviceTypeName"] = this.serviceTypeName;
        data["serviceTypeDescription"] = this.serviceTypeDescription;
        return data;
    }
}

export interface IUpdateServiceTypeCommand {
    serviceTypeId?: number;
    serviceTypeName?: string;
    serviceTypeDescription?: string;
}

export class ApiResponseOfIListOfUserDto implements IApiResponseOfIListOfUserDto {
    status?: string;
    data?: UserDto[] | undefined;
    message?: string;

    constructor(data?: IApiResponseOfIListOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserDto.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfIListOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfIListOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfIListOfUserDto {
    status?: string;
    data?: UserDto[] | undefined;
    message?: string;
}

export class ApiResponseOfUserDto implements IApiResponseOfUserDto {
    status?: string;
    data?: UserDto | undefined;
    message?: string;

    constructor(data?: IApiResponseOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? UserDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfUserDto {
    status?: string;
    data?: UserDto | undefined;
    message?: string;
}

export class CreateUserCommand implements ICreateUserCommand {
    email?: string;
    roleIds?: number[];

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface ICreateUserCommand {
    email?: string;
    roleIds?: number[];
}

export class UpdateUserCommand implements IUpdateUserCommand {
    userId?: string;
    email?: string;
    roleIds?: number[];

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserCommand {
    userId?: string;
    email?: string;
    roleIds?: number[];
}

export class ApiResponseOfVacancyDto implements IApiResponseOfVacancyDto {
    status?: string;
    data?: VacancyDto | undefined;
    message?: string;

    constructor(data?: IApiResponseOfVacancyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? VacancyDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfVacancyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfVacancyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfVacancyDto {
    status?: string;
    data?: VacancyDto | undefined;
    message?: string;
}

export class VacancyDto extends BaseDto implements IVacancyDto {
    vacancyId?: number;
    position?: string;
    description?: string;
    closingDate?: Date;
    location?: string;
    responsibilities?: string;
    requirements?: string;
    jobCategory?: string;
    jobType?: string;
    vacancyApplications?: VacancyApplicationDto[] | undefined;

    constructor(data?: IVacancyDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vacancyId = _data["vacancyId"];
            this.position = _data["position"];
            this.description = _data["description"];
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.responsibilities = _data["responsibilities"];
            this.requirements = _data["requirements"];
            this.jobCategory = _data["jobCategory"];
            this.jobType = _data["jobType"];
            if (Array.isArray(_data["vacancyApplications"])) {
                this.vacancyApplications = [] as any;
                for (let item of _data["vacancyApplications"])
                    this.vacancyApplications!.push(VacancyApplicationDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VacancyDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacancyId"] = this.vacancyId;
        data["position"] = this.position;
        data["description"] = this.description;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["responsibilities"] = this.responsibilities;
        data["requirements"] = this.requirements;
        data["jobCategory"] = this.jobCategory;
        data["jobType"] = this.jobType;
        if (Array.isArray(this.vacancyApplications)) {
            data["vacancyApplications"] = [];
            for (let item of this.vacancyApplications)
                data["vacancyApplications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IVacancyDto extends IBaseDto {
    vacancyId?: number;
    position?: string;
    description?: string;
    closingDate?: Date;
    location?: string;
    responsibilities?: string;
    requirements?: string;
    jobCategory?: string;
    jobType?: string;
    vacancyApplications?: VacancyApplicationDto[] | undefined;
}

export class VacancyApplicationDto implements IVacancyApplicationDto {
    vacancyApplicationId?: number;
    vacancyId?: number;
    name?: string;
    email?: string;
    phone?: string;
    status?: VacancyStatus;
    createdAt?: Date;
    vacancyApplicationAttachments?: VacancyApplicationAttachmentDto[];

    constructor(data?: IVacancyApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vacancyApplicationId = _data["vacancyApplicationId"];
            this.vacancyId = _data["vacancyId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["vacancyApplicationAttachments"])) {
                this.vacancyApplicationAttachments = [] as any;
                for (let item of _data["vacancyApplicationAttachments"])
                    this.vacancyApplicationAttachments!.push(VacancyApplicationAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VacancyApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacancyApplicationId"] = this.vacancyApplicationId;
        data["vacancyId"] = this.vacancyId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        if (Array.isArray(this.vacancyApplicationAttachments)) {
            data["vacancyApplicationAttachments"] = [];
            for (let item of this.vacancyApplicationAttachments)
                data["vacancyApplicationAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVacancyApplicationDto {
    vacancyApplicationId?: number;
    vacancyId?: number;
    name?: string;
    email?: string;
    phone?: string;
    status?: VacancyStatus;
    createdAt?: Date;
    vacancyApplicationAttachments?: VacancyApplicationAttachmentDto[];
}

export enum VacancyStatus {
    Pending = 1,
    Viewed = 2,
    Rejected = 3,
    Shortlisted = 4,
}

export class VacancyApplicationAttachmentDto implements IVacancyApplicationAttachmentDto {
    vacancyApplicationAttachmentId?: number;
    vacancyApplicationId?: number;
    name?: string;
    url?: string;

    constructor(data?: IVacancyApplicationAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vacancyApplicationAttachmentId = _data["vacancyApplicationAttachmentId"];
            this.vacancyApplicationId = _data["vacancyApplicationId"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): VacancyApplicationAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyApplicationAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacancyApplicationAttachmentId"] = this.vacancyApplicationAttachmentId;
        data["vacancyApplicationId"] = this.vacancyApplicationId;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface IVacancyApplicationAttachmentDto {
    vacancyApplicationAttachmentId?: number;
    vacancyApplicationId?: number;
    name?: string;
    url?: string;
}

export class ApiResponseOfVacancyApplicationDto implements IApiResponseOfVacancyApplicationDto {
    status?: string;
    data?: VacancyApplicationDto | undefined;
    message?: string;

    constructor(data?: IApiResponseOfVacancyApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? VacancyApplicationDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfVacancyApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfVacancyApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfVacancyApplicationDto {
    status?: string;
    data?: VacancyApplicationDto | undefined;
    message?: string;
}

export class UpdateVacancyApplicationCommand implements IUpdateVacancyApplicationCommand {
    vacancyApplicationId?: number;
    status?: VacancyStatus;

    constructor(data?: IUpdateVacancyApplicationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vacancyApplicationId = _data["vacancyApplicationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateVacancyApplicationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVacancyApplicationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacancyApplicationId"] = this.vacancyApplicationId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateVacancyApplicationCommand {
    vacancyApplicationId?: number;
    status?: VacancyStatus;
}

export class ApiResponseOfIListOfVacancyWithApplicationCount implements IApiResponseOfIListOfVacancyWithApplicationCount {
    status?: string;
    data?: VacancyWithApplicationCount[] | undefined;
    message?: string;

    constructor(data?: IApiResponseOfIListOfVacancyWithApplicationCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VacancyWithApplicationCount.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfIListOfVacancyWithApplicationCount {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfIListOfVacancyWithApplicationCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfIListOfVacancyWithApplicationCount {
    status?: string;
    data?: VacancyWithApplicationCount[] | undefined;
    message?: string;
}

export class VacancyWithApplicationCount implements IVacancyWithApplicationCount {
    vacancy?: Vacancy;
    applicationCount?: number;

    constructor(data?: IVacancyWithApplicationCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vacancy = _data["vacancy"] ? Vacancy.fromJS(_data["vacancy"]) : <any>undefined;
            this.applicationCount = _data["applicationCount"];
        }
    }

    static fromJS(data: any): VacancyWithApplicationCount {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyWithApplicationCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacancy"] = this.vacancy ? this.vacancy.toJSON() : <any>undefined;
        data["applicationCount"] = this.applicationCount;
        return data;
    }
}

export interface IVacancyWithApplicationCount {
    vacancy?: Vacancy;
    applicationCount?: number;
}

export class Vacancy extends BaseAuditableEntity implements IVacancy {
    vacancyId?: number;
    position?: string;
    description?: string;
    closingDate?: Date;
    location?: string;
    responsibilities?: string;
    requirements?: string;
    jobCategory?: string;
    jobType?: string;
    vacancyApplications?: VacancyApplication[] | undefined;

    constructor(data?: IVacancy) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vacancyId = _data["vacancyId"];
            this.position = _data["position"];
            this.description = _data["description"];
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.responsibilities = _data["responsibilities"];
            this.requirements = _data["requirements"];
            this.jobCategory = _data["jobCategory"];
            this.jobType = _data["jobType"];
            if (Array.isArray(_data["vacancyApplications"])) {
                this.vacancyApplications = [] as any;
                for (let item of _data["vacancyApplications"])
                    this.vacancyApplications!.push(VacancyApplication.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Vacancy {
        data = typeof data === 'object' ? data : {};
        let result = new Vacancy();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacancyId"] = this.vacancyId;
        data["position"] = this.position;
        data["description"] = this.description;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["responsibilities"] = this.responsibilities;
        data["requirements"] = this.requirements;
        data["jobCategory"] = this.jobCategory;
        data["jobType"] = this.jobType;
        if (Array.isArray(this.vacancyApplications)) {
            data["vacancyApplications"] = [];
            for (let item of this.vacancyApplications)
                data["vacancyApplications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IVacancy extends IBaseAuditableEntity {
    vacancyId?: number;
    position?: string;
    description?: string;
    closingDate?: Date;
    location?: string;
    responsibilities?: string;
    requirements?: string;
    jobCategory?: string;
    jobType?: string;
    vacancyApplications?: VacancyApplication[] | undefined;
}

export class VacancyApplication implements IVacancyApplication {
    vacancyApplicationId?: number;
    vacancyId?: number;
    name?: string;
    email?: string;
    phone?: string;
    status?: number;
    createdAt?: Date;
    vacancyApplicationAttachments?: VacancyApplicationAttachment[];

    constructor(data?: IVacancyApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vacancyApplicationId = _data["vacancyApplicationId"];
            this.vacancyId = _data["vacancyId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["vacancyApplicationAttachments"])) {
                this.vacancyApplicationAttachments = [] as any;
                for (let item of _data["vacancyApplicationAttachments"])
                    this.vacancyApplicationAttachments!.push(VacancyApplicationAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VacancyApplication {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacancyApplicationId"] = this.vacancyApplicationId;
        data["vacancyId"] = this.vacancyId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        if (Array.isArray(this.vacancyApplicationAttachments)) {
            data["vacancyApplicationAttachments"] = [];
            for (let item of this.vacancyApplicationAttachments)
                data["vacancyApplicationAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVacancyApplication {
    vacancyApplicationId?: number;
    vacancyId?: number;
    name?: string;
    email?: string;
    phone?: string;
    status?: number;
    createdAt?: Date;
    vacancyApplicationAttachments?: VacancyApplicationAttachment[];
}

export class VacancyApplicationAttachment implements IVacancyApplicationAttachment {
    vacancyApplicationAttachmentId?: number;
    vacancyApplicationId?: number;
    name?: string;
    url?: string;

    constructor(data?: IVacancyApplicationAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vacancyApplicationAttachmentId = _data["vacancyApplicationAttachmentId"];
            this.vacancyApplicationId = _data["vacancyApplicationId"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): VacancyApplicationAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyApplicationAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacancyApplicationAttachmentId"] = this.vacancyApplicationAttachmentId;
        data["vacancyApplicationId"] = this.vacancyApplicationId;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface IVacancyApplicationAttachment {
    vacancyApplicationAttachmentId?: number;
    vacancyApplicationId?: number;
    name?: string;
    url?: string;
}

export class ApiResponseOfIListOfVacancyDto implements IApiResponseOfIListOfVacancyDto {
    status?: string;
    data?: VacancyDto[] | undefined;
    message?: string;

    constructor(data?: IApiResponseOfIListOfVacancyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VacancyDto.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiResponseOfIListOfVacancyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfIListOfVacancyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IApiResponseOfIListOfVacancyDto {
    status?: string;
    data?: VacancyDto[] | undefined;
    message?: string;
}

export class CreateVacancyCommand implements ICreateVacancyCommand {
    position?: string;
    description?: string;
    closingDate?: Date;
    location?: string;
    responsibilities?: string;
    requirements?: string;
    jobCategory?: string;
    jobType?: string;

    constructor(data?: ICreateVacancyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.description = _data["description"];
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.responsibilities = _data["responsibilities"];
            this.requirements = _data["requirements"];
            this.jobCategory = _data["jobCategory"];
            this.jobType = _data["jobType"];
        }
    }

    static fromJS(data: any): CreateVacancyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVacancyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["description"] = this.description;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["responsibilities"] = this.responsibilities;
        data["requirements"] = this.requirements;
        data["jobCategory"] = this.jobCategory;
        data["jobType"] = this.jobType;
        return data;
    }
}

export interface ICreateVacancyCommand {
    position?: string;
    description?: string;
    closingDate?: Date;
    location?: string;
    responsibilities?: string;
    requirements?: string;
    jobCategory?: string;
    jobType?: string;
}

export class UpdateVacancyCommand implements IUpdateVacancyCommand {
    vacancyId?: number;
    position?: string;
    description?: string;
    closingDate?: Date;
    location?: string;
    responsibilities?: string;
    requirements?: string;
    jobCategory?: string;
    jobType?: string;

    constructor(data?: IUpdateVacancyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vacancyId = _data["vacancyId"];
            this.position = _data["position"];
            this.description = _data["description"];
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.responsibilities = _data["responsibilities"];
            this.requirements = _data["requirements"];
            this.jobCategory = _data["jobCategory"];
            this.jobType = _data["jobType"];
        }
    }

    static fromJS(data: any): UpdateVacancyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVacancyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacancyId"] = this.vacancyId;
        data["position"] = this.position;
        data["description"] = this.description;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["responsibilities"] = this.responsibilities;
        data["requirements"] = this.requirements;
        data["jobCategory"] = this.jobCategory;
        data["jobType"] = this.jobType;
        return data;
    }
}

export interface IUpdateVacancyCommand {
    vacancyId?: number;
    position?: string;
    description?: string;
    closingDate?: Date;
    location?: string;
    responsibilities?: string;
    requirements?: string;
    jobCategory?: string;
    jobType?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}